"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const wait_1 = require("./wait");
class AsyncPolling {
    constructor(cb, ms) {
        this.polling = false;
        this.started = false;
        this.paused = false;
        this.cancelWait = () => { };
        this.cb = cb;
        this.ms = ms;
    }
    async poll() {
        if (!this.paused) {
            await this.cb();
        }
        const { wait, cancel } = (0, wait_1.cancellableWait)(this.ms);
        this.cancelWait = cancel;
        await wait();
        if (this.polling) {
            this.poll();
        }
    }
    pause() {
        this.paused = true;
    }
    unpause() {
        this.paused = false;
    }
    trigger() {
        this.cancelWait();
        this.poll();
    }
    start() {
        if (!this.started) {
            this.started = true;
            this.polling = true;
            this.poll();
        }
        else {
            throw new Error('AsyncPolling cannot be started twice');
        }
    }
    stop() {
        if (this.started) {
            this.polling = false;
        }
    }
}
exports.default = AsyncPolling;
